import { Autocomplete, Checkbox, FormControlLabel, FormHelperText, Grid, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadOrganizations } from "../../actions";
import Config from "../../config";
import { countries, states } from "../../helpers/countries";
import { debounce } from "../../helpers/debounce";
import { setBackHandler, setRefreshHandler } from "../../helpers/header.helper";
import setToast from "../../helpers/toaster.helper";
import { LandlineSubscriberFormData, PhoneNumberData } from "../../models/add-phone-number.model";
import { mapToOrganizationDetails, OrganizationModel } from "../../models/organization.model";
import { mapToPhoneNumber, PhoneNumberStatus } from "../../models/phone-number.model";
import { SettingsModel } from "../../models/settings-model";
import * as selector from "../../selectors/selectors";
import { EmailService } from "../../services/email.service";
import { ExternalServices } from "../../services/external.service";
import { OrganizationService } from "../../services/OrganizationService";
import { PhoneNumberService } from "../../services/PhonenumberService";
import { UserService } from "../../services/UserService";
import { UtilityService } from "../../services/UtilityService";
import ButtonComponent from "../shared/button/button.component";
import { appNote, buttonLabels, TextFieldLabels, ToasterTexts } from "../shared/constants";
import { validateForm } from "../shared/form-validation";
import { ToasterType } from "../shared/toaster/toaster.model";
import VoiceVerification from "../add-phone-number/voiceVerification";
import RegistrationStatus from "../add-phone-number/registrationStatus.component";


const selectProduct = [
    {
        "Name": "Landline Texting",
        "Value": 0
    },
    {
        "Name": "VOIP Texting",
        "Value": 1
    },
    {
        "Name": "MS Teams Texting",
        "Value": 2
    },
    {
        "Name": "Toll free Texting ",
        "Value": 3
    },
]
const NewAddPhoneNumber = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    let PT = selectProduct.find((x) => x.Value === state?.ProductType)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const Settingobj: SettingsModel = useSelector(selector.settingsObj)
    const Organizations: OrganizationModel[] = useSelector(selector.newOrganizations)
    const [phonenumberData, setPhonenumberData] = useState<PhoneNumberData>({
        Name: state ? state.Name : "",
        Organization: undefined,
        PhoneNumber: state ? state.PhoneNumber : "",
        SelectProduct: state ? PT?.Value : undefined,
        id: "",
        organizationId: "",
        number: "",
        status: "",
        plans: [],
        message: "",
        VerificationCount: 0,
        CloseAllowed: false
    });
    const [disableForm, setDisableForm] = useState<boolean>(false);
    const [useOrgAddess, setUseOrgAddress] = useState<boolean>(false);
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [regitrationstatus, setRegitrationstatus] = useState<boolean>(false)
    const [status, setStatus] = useState<boolean>()
    const [voiceVerification, setVoiceVerification] = useState<boolean>(Settingobj.VoiceVerificationEnabled)
    const [verificationStatus, setVerificationStatus] = useState<boolean>(true)
    const [successnote, setSuccessNote] = useState<boolean>(false)
    const [address, setAddress] = useState<LandlineSubscriberFormData>({
        FirstName: "",
        LastName: "",
        HouseNumber: "",
        Address: "",
        ZipCode: "",
        City: "",
        State: "",
        Country: ""
    });
    const [errors, setErrors] = useState({
        Name: "", PhoneNumber: "", OrganizationID: "", selectproduct: "",
        firstname: "", lastname: "", HouseNumber: "", Address: "", ZipCode: "", City: "", state: "", country: ""
    });
    const [isTouched, setIsTouched] = useState({
        Name: false, PhoneNumber: false, OrganizationID: false, selectProduct: false,
        FirstName: false, LastName: false, HouseNumber: false, Address: false, ZipCode: false, City: false, State: false, country: false
    });

    const ValidateForm = () => validateForm(UserService.hasSysAdminRole() ?
        {
            Name: phonenumberData.Name, PhoneNumber: phonenumberData.PhoneNumber, OrganizationID: phonenumberData.Organization?.ID, firstname: address.FirstName,
            lastname: address.LastName, HouseNumber: address.HouseNumber, Address: address.Address, ZipCode: address.ZipCode, City: address.City, state: address.State, country: address.Country
        }
        : {
            Name: phonenumberData.Name, PhoneNumber: phonenumberData.PhoneNumber, firstname: address.FirstName,
            lastname: address.LastName, HouseNumber: address.HouseNumber, Address: address.Address, ZipCode: address.ZipCode, City: address.City, state: address.State, country: address.Country
        },
        (newErrors) => {
            setErrors(prevErrors => ({
                ...prevErrors,
                ...newErrors,
            }));
        })
    const handleNameChange = (name, value) => {
        setIsTouched({ ...isTouched, [name]: true })
        validateForm({ [name]: value },
            (Errors) => {
                setErrors({ ...errors, ...Errors });
            })
        setPhonenumberData({ ...phonenumberData, [name]: value })
        setAddress({ ...address, [name]: value })
    }

    const inputRef = useRef(null)
    const handlePhoneNumberChange = (name, value) => {
        const inputElement = inputRef.current;
        if (!inputElement) return;
        const cursorStart = inputElement.selectionStart || 0;
        setIsTouched({ ...isTouched, [name]: true })
        validateForm({ [name]: value },
            (Errors) => {
                setErrors({ ...errors, ...Errors });
            })
        const oldValue = inputElement.value;
        const rawDigits = value.replace(/[^\d]/g, "");
        const formattedValue = UtilityService.maskPhoneNumber(rawDigits);
        setPhonenumberData({ ...phonenumberData, [name]: value })
        const newCursorPos = calculateNewCursorPos(oldValue, formattedValue, cursorStart);
        requestAnimationFrame(() => {
            if (document.activeElement === inputElement) {
                inputElement.value = formattedValue;
                inputElement.setSelectionRange(newCursorPos, newCursorPos);
            }
        });
    };

    const calculateNewCursorPos = (oldValue, newValue, oldCursorPos) => {
        const digitsBeforeCursor = oldValue
            .slice(0, oldCursorPos)
            .replace(/[^\d]/g, '').length;
        let newPos = 0;
        let digitCount = 0;
        while (digitCount < digitsBeforeCursor && newPos < newValue.length) {
            if (/\d/.test(newValue[newPos])) {
                digitCount++;
            }
            newPos++;
        }
        return newPos;
    };

    const onBlur = (e: any) => {
        setIsTouched({ ...isTouched, [e.target.name]: true })
    }

    const handleOrgChnage = (orgId: string) => {
        if (orgId) {
            setTimeout(() => {
                setErrors({ ...errors, OrganizationID: "" });
            }, 0);
            setUseOrgAddress(false)
            setAddress({ ...address, HouseNumber: "", Address: "", ZipCode: "", City: "", State: "", Country: "" });
            fetchOrganizationDetails(orgId);
        }
        else {
            setIsTouched({ ...isTouched, OrganizationID: true })
            setErrors({ ...errors, OrganizationID: "Organization cannot be blank" })
            setUseOrgAddress(false)
            setAddress({ ...address, HouseNumber: "", Address: "", ZipCode: "", City: "", State: "", Country: "" });
            setPhonenumberData({ ...phonenumberData, Organization: null });
        }
    };

    const fetchOrganizationDetails = (orgId: string) => {
        OrganizationService.getOrganizationById(UserService.hasSysAdminRole() ? orgId : UserService.getCurrentUserOrgId()).then(res => {
            let org = mapToOrganizationDetails(res.data);
            setPhonenumberData({
                ...phonenumberData,
                Organization: org
            });
        }).catch(error => {
        })
    }

    const handleProductChange = (value: any) => {
        setIsTouched({ ...isTouched, selectProduct: true })
        let Value = value ? value.Value : undefined
        setPhonenumberData({ ...phonenumberData, SelectProduct: Value })
    }

    const handleSameOrgAddress = (e: any) => {
        setUseOrgAddress(e.target.checked)
        if (e.target.checked) {
            if (phonenumberData.Organization?.ID !== undefined) {
                setDisableForm(true);
                setAddress({
                    ...address,
                    HouseNumber: phonenumberData.Organization?.HouseNumber,
                    Address: phonenumberData.Organization?.Address,
                    ZipCode: phonenumberData.Organization?.ZipCode,
                    City: phonenumberData.Organization?.City,
                    Country: phonenumberData.Organization?.Country,
                    State: phonenumberData.Organization?.State,
                })
                setDisableForm(false);
            }
        }
        else if (phonenumberData.Organization?.ID === undefined) {
            OrganizationService.getOrganizationById(UserService.hasSysAdminRole() ? phonenumberData.Organization?.ID : UserService.getCurrentUserOrgId())
                .then(res => {
                    let org = mapToOrganizationDetails(res.data);
                    setAddress({
                        ...address,
                        HouseNumber: org.HouseNumber,
                        Address: org.Address,
                        ZipCode: org.ZipCode,
                        City: org.City,
                        State: org.State,
                        Country: org.Country
                    });
                })
        }
        else {
            setAddress({ ...address, HouseNumber: "", Address: "", ZipCode: "", City: "", State: "", Country: "" });
        }
    };

    const refresh = () => {
        setPhonenumberData({ ...phonenumberData, Name: "", Organization: undefined, PhoneNumber: "", SelectProduct: undefined, });
        setAddress({ ...address, FirstName: "", LastName: "", HouseNumber: "", Address: "", ZipCode: "", City: "", State: "", Country: "" });
        setErrors({
            ...errors, Name: "", PhoneNumber: "", OrganizationID: "", selectproduct: "",
            firstname: "", lastname: "", HouseNumber: "", Address: "", ZipCode: "", City: "", state: "", country: ""
        });
        setIsTouched({
            ...isTouched, Name: false, PhoneNumber: false, OrganizationID: false, selectProduct: false,
            FirstName: false, LastName: false, HouseNumber: false, Address: false, ZipCode: false, City: false, State: false, country: false
        });
        setUseOrgAddress(false)
        setSuccessNote(false)

        if (!UserService.hasSysAdminRole())
            OrganizationService.getOrganizationById(UserService.getCurrentUserOrgId()).then(res => {
                let org = mapToOrganizationDetails(res.data);
                setPhonenumberData({
                    ...phonenumberData,
                    Organization: org
                });
            })
    }

    const onZipCodeChange = debounce(() => {
        const currentZipCode = address.ZipCode;
        if (currentZipCode.length >= 3) {
            ExternalServices.zipLookup(currentZipCode)
                .then((data) => {
                    setAddress({ ...address, ...data })
                })
                .catch((error) => {
                    setErrors({ ...error, ZipCode: error });
                    setToast(error, ToasterType.DANGER);
                });
        }
        else if (currentZipCode.length === 0) {
            setErrors({ ...errors, ZipCode: "ZipCode cannot be blank" });
        }
    }, 500);

    useEffect(() => {
        setVoiceVerification(Settingobj.VoiceVerificationEnabled)
    }, [Settingobj])


    useEffect(() => {
        if (phonenumberData.status) {
            if ((!state?.IsReHost && (phonenumberData.status === PhoneNumberStatus.PAYMENT_DUE)) || (phonenumberData.status === PhoneNumberStatus.ACTIVE)) {
                setStatus(true)
            }
            else {
                setTimeout(() => {
                    checkstatus(phonenumberData.id);
                }, 8000)
            }
        }
    }, [phonenumberData.status])

    const checkstatus = (id: string) => {
        PhoneNumberService.checkPhoneNumberStatus(id).then((res) => {
            if (res && res.status === 200 && res.data && res.data.phoneStatus) {
                setPhonenumberData({ ...phonenumberData, status: res.data.phoneStatus })
            }
        })
    }

    const formSubmit = (e: any) => {
        if ((UserService.hasSysAdminRole() || (phonenumberData.SelectProduct === 0 || phonenumberData.SelectProduct === 3 || phonenumberData.SelectProduct === undefined))) {
            if (state?.VerificationCount >= 2) {
                return;
            }
            e.preventDefault();
            const formdata = {
                organizationId: UserService.hasSysAdminRole() ? phonenumberData.Organization?.ID : UserService.getCurrentUserOrgId(),
                name: phonenumberData.Name,
                code: "",
                number: UtilityService.unmaskPhoneNumber(phonenumberData.PhoneNumber),
                productType: phonenumberData.SelectProduct,
                address: {
                    loaPersonName: `${address.FirstName} ${address.LastName}`,
                    houseNumber: address.HouseNumber,
                    streetName: address.Address,
                    city: address.City,
                    stateCode: address.State,
                    zip: address.ZipCode,
                    county: address.Country
                }
            };
            setIsTouched({ ...isTouched, Name: true, PhoneNumber: true, OrganizationID: true, FirstName: true, LastName: true, HouseNumber: true, Address: true, ZipCode: true, City: true, State: true, country: true })
            if (ValidateForm()) {
                setRegitrationstatus(true)
                setStatus(false)
                setShowLoader(true)
                let promise = state?.IsReHost ?
                    voiceVerification === false ?
                        PhoneNumberService.reHostPhoneNumberVerifyVoiceOTP(formdata) :
                        PhoneNumberService.reHostPhoneNumberSendVoiceOTP(formdata)
                    :
                    voiceVerification === false ?
                        PhoneNumberService.verifyVoiceOTP(formdata) :
                        PhoneNumberService.sendVoiceOTP(formdata);
                promise.then(res => {
                    setPhonenumberData({
                        ...phonenumberData, ...res.data, VerificationCount: 0, CloseAllowed: !!voiceVerification,
                        ...(!voiceVerification ? mapToPhoneNumber(res.data) : {})
                    })
                    setShowLoader(false);
                    setIsTouched({ ...isTouched, Name: false, PhoneNumber: false, OrganizationID: false, FirstName: false, LastName: false, HouseNumber: false, Address: false, ZipCode: false, City: false, State: false, country: false })
                    setVerificationStatus(true)
                })
                    .catch((error) => {
                        if (error.response.status === 400 && error.response.data.code === "DUPLICATE") {
                            setRegitrationstatus(false)
                            setShowLoader(false);
                            setIsTouched({ ...isTouched, FirstName: false, LastName: false, HouseNumber: false, Address: false, ZipCode: false, City: false, State: false, country: false })
                            setToast(ToasterTexts.PHONE_NUMBER_EXISTS.replace("<number>", UtilityService.maskPhoneNumber(phonenumberData.PhoneNumber)), ToasterType.DANGER)
                        }
                        else if (error.response.status === 400 && error.response.data.code === "INVALIDHOST") {
                            setRegitrationstatus(false)
                            setShowLoader(false);
                            setIsTouched({ ...isTouched, FirstName: false, LastName: false, HouseNumber: false, Address: false, ZipCode: false, City: false, State: false, country: false })
                            setToast(ToasterTexts.PHONE_NUMBER_NOT_VALID.replace("<number>", UtilityService.maskPhoneNumber(phonenumberData.PhoneNumber)), ToasterType.DANGER)
                        }
                        else if (error.response.status === 500) {
                            setRegitrationstatus(false)
                            setShowLoader(false);
                            setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
                        }
                    })
            }
        }
        else {

            setIsTouched({ ...isTouched, Name: true, PhoneNumber: true, OrganizationID: true, selectProduct: true, FirstName: true, LastName: true, HouseNumber: true, Address: true, ZipCode: true, City: true, State: true, country: true })
            UserService.getCurrentUser().then((res: any) => {
                OrganizationService.getOrganizationById(UserService.getCurrentUserOrgId())
                    .then((org: any) => {
                        let orgdata = mapToOrganizationDetails(org.data)
                        EmailService.sendVoipEmailNotificationtoSupport(
                            [{ Name: phonenumberData.Name, Email: Config.SUPPORT_EMAIL }], {
                            ProductName: phonenumberData.SelectProduct === 1 ? appNote.VOIP_TEXTING : appNote.MS_TEAMS_TEXTING,
                            FirstName: res.data.firstName,
                            LastName: res.data.lastName,
                            Email: res.data.email,
                            MobileNumber: res.data.phoneNumber,
                            Organization: orgdata.Name,
                            Industry: orgdata.Industry,
                            HouseNumber: orgdata.HouseNumber,
                            StreetName: orgdata.Address,
                            Zipcode: orgdata.ZipCode,
                            City: orgdata.City,
                            State: orgdata.State,
                            Country: orgdata.Country,
                            Name: phonenumberData.Name,
                            PhoneNumber: UtilityService.maskPhoneNumber(phonenumberData.PhoneNumber),
                        }).then(x => {
                            setShowLoader(false);
                            setSuccessNote(true)
                            setIsTouched({ ...isTouched, Name: false, PhoneNumber: false, OrganizationID: false, selectProduct: false, FirstName: false, LastName: false, HouseNumber: false, Address: false, ZipCode: false, City: false, State: false, country: false })
                            setPhonenumberData({ ...phonenumberData, Name: "", PhoneNumber: "", SelectProduct: -1 })
                        })
                        EmailService.sendVoipEmailNotificationtoUser([{ Email: res.data.email, Name: "" }], {
                            FirstName: res.data.firstName
                        })
                    })
            })
        }
    }

    const handleVerificationStatus = (data) => {
        setVerificationStatus(data)
    }

    useEffect(() => {
        ValidateForm();
    }, [phonenumberData, address])

    useEffect(() => {
        LoadOrganizations(dispatch);
        setRefreshHandler(refresh)
        setBackHandler(() => navigate(-1))
    }, [])


    useEffect(() => {
        OrganizationService.getOrganizationById(UserService.hasSysAdminRole() ? state?.OrganizationID : UserService.getCurrentUserOrgId()).then(res => {
            let org = mapToOrganizationDetails(res.data);
            setPhonenumberData({
                ...phonenumberData,
                Organization: org
            });
        }).catch(error => { })
    }, [state?.OrganizationID])

    return (
        <div className=" bg-color-current-plan-background p-5 h-fill o-y-auto ">
            {
                regitrationstatus === false ?
                    <form >
                        <Grid container direction="column" className={'paper-background br-2 b-around-text-field-border-4 p-5'}>
                            <Grid container direction="row"  >
                                <Grid container md={(UserService.hasSysAdminRole() || (phonenumberData.SelectProduct === 0 || phonenumberData.SelectProduct === 3 || phonenumberData.SelectProduct === undefined)) ? 5 : 12} spacing={3} className={'d-flex justify-center '} >
                                    <Grid item xs={10} >
                                        <label className="h5-regular color-text-field-label mb-1 " htmlFor="Name">
                                            {TextFieldLabels.NAME}
                                        </label>
                                        <TextField
                                            name="Name"
                                            placeholder={"Name *"}
                                            fullWidth
                                            value={phonenumberData.Name}
                                            variant="outlined"
                                            onChange={(e) => {
                                                handleNameChange(e.target.name, e.target.value)
                                            }}
                                            onBlur={onBlur}
                                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                            size="small"
                                            disabled={!!state}
                                            autoComplete='no' />
                                        {
                                            isTouched.Name && errors.Name &&
                                            <FormHelperText className={'h6-regular  color-primary-danger t-align-right'}>
                                                {errors.Name}
                                            </FormHelperText>
                                        }
                                    </Grid>

                                    <Grid item xs={10} >
                                        <label className="h5-regular color-text-field-label mb-1" htmlFor="PhoneNumber">
                                            {TextFieldLabels.PHONE_NUMBER}
                                        </label>
                                        <TextField
                                            name="PhoneNumber"
                                            placeholder="Phone Number *"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={UtilityService.maskPhoneNumber(phonenumberData.PhoneNumber)}
                                            onChange={(e) => { handlePhoneNumberChange(e.target.name, e.target.value) }}
                                            onBlur={onBlur}
                                            disabled={!!state}
                                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                            autoComplete='no'
                                            inputRef={inputRef} />
                                        {
                                            isTouched.PhoneNumber && errors.PhoneNumber &&
                                            <FormHelperText className={'h6-regular  color-primary-danger t-align-right'}>
                                                {errors.PhoneNumber}
                                            </FormHelperText>
                                        }
                                    </Grid>

                                    <Grid item xs={10} className={`${IsMobileDevice && 'mb-5'}`}>
                                        {
                                            isTouched.selectProduct && errors.selectproduct &&
                                            <FormHelperText className={'h6-regular  color-primary-danger t-align-right'}>
                                                {errors.selectproduct}
                                            </FormHelperText>
                                        }
                                    </Grid>
                                    {UserService.hasSysAdminRole() &&
                                        <Grid item xs={10} >
                                            <label className="h5-regular color-text-field-label mb-1" htmlFor="PhoneNumber">
                                                {TextFieldLabels.ORGANIZATION}
                                            </label>
                                            <Autocomplete
                                                onBlur={onBlur}
                                                size="small"
                                                className={"w-fill"}
                                                classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                                options={Organizations.filter(x => (x.Name !== null && x.Name !== "Admin" && !x.IsDeleted))}
                                                value={!!phonenumberData.Organization?.ID ? (Organizations.find((x) => x.ID === phonenumberData.Organization?.ID || null)) : null}
                                                getOptionLabel={(option: any) => option?.Name}
                                                onChange={(e: any, value: any) => handleOrgChnage(value?.ID || "")}
                                                disabled={!!state}
                                                renderOption={(defaultprops, option: any) => (
                                                    <li {...defaultprops} >
                                                        <span className={'c-poinet h4-regular color-menu-list-font-color p-2 d-flex justify-between w-p-90'}>
                                                            {option.Name}
                                                        </span>
                                                    </li>
                                                )}
                                                renderInput={(params) => <TextField {...params} size="small" variant="outlined" placeholder="Organization *" name="OrganizationID" />} />
                                            {
                                                isTouched.OrganizationID && errors.OrganizationID &&
                                                <FormHelperText className={'h6-regular color-primary-danger t-align-right'}>
                                                    {errors.OrganizationID}
                                                </FormHelperText>
                                            }
                                        </Grid>}
                                </Grid>
                                {(UserService.hasSysAdminRole() || (phonenumberData.SelectProduct === 0 || phonenumberData.SelectProduct === 3 || phonenumberData.SelectProduct === undefined)) && <div className={"b-around-text-field-border-4"}></div>}
                                {(UserService.hasSysAdminRole() || (phonenumberData.SelectProduct === 0 || phonenumberData.SelectProduct === 3 || phonenumberData.SelectProduct === undefined)) &&
                                    <Grid container md={7} spacing={3} className={'d-flex justify-center'}>
                                        <Grid item xs={10} className="p-1">
                                            <span className={'h2-regular'}>{appNote.ADDRESS}:</span>
                                        </Grid>
                                        <Grid item xs={10} sm={5} className="p-1">
                                            <label className="h5-regular color-text-field-label mb-1" htmlFor="FirstName">
                                                {TextFieldLabels.FIRST_NAME}
                                            </label>
                                            <TextField
                                                placeholder="First Name *"
                                                name="FirstName"
                                                fullWidth
                                                value={address.FirstName}
                                                onChange={(e) => handleNameChange(e.target.name, e.target.value)}
                                                onBlur={onBlur}
                                                variant="outlined"
                                                InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                                size="small"
                                                autoComplete='no'
                                            />
                                            {isTouched.FirstName && errors.firstname && <FormHelperText className=" h5-regular color-primary-danger t-align-right">
                                                {errors.firstname}
                                            </FormHelperText>}
                                        </Grid>
                                        <Grid item xs={10} sm={5} className="p-1">
                                            <label className="h5-regular color-text-field-label mb-1" htmlFor="LastName">
                                                {TextFieldLabels.LAST_NAME}
                                            </label>
                                            <TextField
                                                placeholder="Last Name *"
                                                name="LastName"
                                                fullWidth
                                                value={address.LastName}
                                                onChange={(e) => handleNameChange(e.target.name, e.target.value)}
                                                onBlur={onBlur}
                                                variant="outlined"
                                                InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                                size="small"
                                                autoComplete='no'
                                            />
                                            {isTouched.LastName && errors.lastname && <FormHelperText className={"h5-regular color-primary-danger t-align-right"}>
                                                {errors.lastname}
                                            </FormHelperText>}
                                        </Grid>
                                        <Grid item xs={10} className="p-1">
                                            <FormControlLabel classes={{ label: 'h5-regular w-space ' }} control={
                                                <Checkbox
                                                    checked={useOrgAddess}
                                                    value={useOrgAddess}
                                                    disabled={!phonenumberData.Organization?.ID}
                                                    onChange={handleSameOrgAddress}
                                                    classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }} name="keepSignedIn" />}
                                                label={appNote.SAME_AS_ORGANIZATION} />
                                        </Grid>
                                        <Grid item xs={10} sm={5} className="p-1">
                                            <label className="h5-regular color-text-field-label mb-1" htmlFor="HouseNumber">
                                                {TextFieldLabels.HOUSE_NUMBER}
                                            </label>
                                            <TextField
                                                placeholder="House Number *"
                                                name="HouseNumber"
                                                fullWidth
                                                value={address.HouseNumber}
                                                onChange={(e) => handleNameChange(e.target.name, e.target.value)}
                                                onBlur={onBlur}
                                                variant="outlined"
                                                InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                                size="small"
                                                autoComplete='no'
                                            />
                                            {isTouched.HouseNumber && errors.HouseNumber && <FormHelperText className={"h5-regular color-primary-danger t-align-right"}>
                                                {errors.HouseNumber}
                                            </FormHelperText>}
                                        </Grid>
                                        <Grid item xs={10} sm={5} className="p-1">
                                            <label className="h5-regular color-text-field-label mb-1" htmlFor="StreetName">
                                                {TextFieldLabels.STREET_NAME}
                                            </label>
                                            <TextField
                                                placeholder="Street Name *"
                                                name="Address"
                                                fullWidth
                                                value={address.Address}
                                                onChange={(e) => handleNameChange(e.target.name, e.target.value)}
                                                onBlur={onBlur}
                                                variant="outlined"
                                                InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                                size="small"
                                                autoComplete='no'
                                            />
                                            {isTouched.Address && errors.Address && <FormHelperText className={"h5-regular color-primary-danger t-align-right"}>
                                                {errors.Address}
                                            </FormHelperText>}
                                        </Grid>
                                        <Grid item xs={10} sm={5} className="p-1">
                                            <label className="h5-regular color-text-field-label mb-1" htmlFor="ZipCode">
                                                {TextFieldLabels.ZIPCODE}
                                            </label>
                                            <TextField
                                                placeholder="Zip Code *"
                                                name="ZipCode"
                                                fullWidth
                                                value={address.ZipCode}
                                                onChange={(e) => {
                                                    setIsTouched({ ...isTouched, ZipCode: true });
                                                    setAddress({
                                                        ...address,
                                                        ZipCode: e.target.value,
                                                        City: e.target.value === "" ? "" : address.City,
                                                        State: e.target.value === "" ? "" : address.State,
                                                        Country: e.target.value === "" ? "" : address.Country
                                                    })
                                                }}
                                                onKeyUp={onZipCodeChange}
                                                onBlur={onBlur}
                                                variant="outlined"
                                                InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                                size="small"
                                                autoComplete='no'
                                            />
                                            {isTouched.ZipCode && errors.ZipCode && <FormHelperText className={"h5-regular color-primary-danger t-align-right"}>
                                                {errors.ZipCode}
                                            </FormHelperText>}
                                        </Grid>
                                        <Grid item xs={10} sm={5} className="p-1">
                                            <label className="h5-regular color-text-field-label mb-1" htmlFor="StreetName">
                                                {TextFieldLabels.CITY}
                                            </label>
                                            <TextField
                                                placeholder="City *"
                                                name="City"
                                                fullWidth
                                                value={address.City}
                                                onChange={(e) => handleNameChange(e.target.name, e.target.value)
                                                }
                                                onBlur={onBlur}
                                                variant="outlined"
                                                InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                                size="small"
                                                autoComplete='no'
                                            />
                                            {isTouched.City && errors.City && <FormHelperText className={"h5-regular color-primary-danger t-align-right"}>
                                                {errors.City}
                                            </FormHelperText>}
                                        </Grid>
                                        <Grid item xs={10} sm={5} className="p-1">
                                            <label className="h5-regular color-text-field-label mb-1" htmlFor="PhoneNumber">
                                                {TextFieldLabels.STATE}
                                            </label>
                                            <Autocomplete
                                                onBlur={onBlur}
                                                size="small"
                                                className={"w-fill"}
                                                classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                                options={(states as any)[address.Country] || []}
                                                value={(states as any)[address.Country]?.find((x: any) => x.ISO === address.State) || { ISO: "", Name: "" }}
                                                getOptionLabel={(option: any) => option?.Name}
                                                onChange={(e: any, value: any) => {
                                                    setIsTouched({ ...isTouched, State: true });
                                                    setAddress({ ...address, State: value?.ISO })
                                                }}
                                                renderOption={(defaultprops, option: any) => (
                                                    <li{...defaultprops}>
                                                        <span className={'c-poinet h4-regular color-menu-list-font-color p-2 d-flex justify-between w-p-90'}>
                                                            {option.Name}
                                                        </span>
                                                    </li>
                                                )}
                                                disabled={!address.Country}
                                                renderInput={(params) => <TextField {...params} size="small" variant="outlined" placeholder="State *" name="State" />} />
                                            {
                                                isTouched.State && errors.state &&
                                                <FormHelperText className={'h6-regular color-primary-danger t-align-right'}>
                                                    {errors.state}
                                                </FormHelperText>
                                            }
                                        </Grid>
                                        <Grid item xs={10} sm={5} className="p-1">
                                            <label className="h5-regular color-text-field-label mb-1" htmlFor="PhoneNumber">
                                                {TextFieldLabels.COUNTRY}
                                            </label>
                                            <Autocomplete
                                                onBlur={onBlur}
                                                size="small"
                                                className={"w-fill"}
                                                classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                                options={countries}
                                                value={countries.find((x) => x.ISO === address.Country) || { ISO: "", Name: "" }}
                                                getOptionLabel={(option: any) => option?.Name}
                                                onChange={(e: any, value: any) => { setIsTouched({ ...isTouched, country: true }); setAddress({ ...address, Country: value?.ISO }) }}
                                                renderOption={(defaultprops, option: any) => (
                                                    <li {...defaultprops}>
                                                        <span className={'c-poinet h4-regular color-menu-list-font-color p-2 d-flex justify-between w-p-90'}>
                                                            {option.Name}
                                                        </span>
                                                    </li>
                                                )}
                                                renderInput={(params) => <TextField {...params} size="small" variant="outlined" placeholder="Country *" name="country" />} />
                                            {
                                                isTouched.country && errors.country &&
                                                <FormHelperText className={'h6-regular color-primary-danger t-align-right'}>
                                                    {errors.country}
                                                </FormHelperText>
                                            }
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                            <Grid item className=" d-flex justify-center pt-5">
                                <ButtonComponent ClassName=" d-flex justify-center br-6 w-50 h-5 p-1 h4-regular " Variant={disableForm ? "disabled-btn" : "primary-btn"} ButtonLabel={(UserService.hasSysAdminRole() || (phonenumberData.SelectProduct === 0 || phonenumberData.SelectProduct === 3 || phonenumberData.SelectProduct === undefined)) ? buttonLabels.ADD_PHONENUMBER : buttonLabels.SUBMIT} OnClick={formSubmit} Loading={showLoader}></ButtonComponent>
                            </Grid>
                            {successnote && <Grid item xs={6} sm={12} md={12} lg={12} xl={12} className={"mx-auto t-align-center p-0"}>
                                <p className={'h5-regular color-primary-success'}>Thank you for submitting.</p>
                                <p className={'h5-regular color-primary-success'}>Our team will get back to you as soon as possible.</p>
                            </Grid>}
                        </Grid>
                    </form>
                    :
                    UserService.hasSysAdminRole() ?
                        (voiceVerification && verificationStatus)
                            ?
                            <Grid container direction="row" className={'paper-background br-2 b-around-text-field-border-4 p-5'} >
                                <VoiceVerification IsMobileDevice={IsMobileDevice} IsRehost={state?.IsReHost} handleStatus={handleVerificationStatus} PhoneNumberData={phonenumberData} AddressData={address} />
                            </Grid>
                            : <Grid container direction="row" className={'paper-background br-2 b-around-text-field-border-4 p-5'} >
                                <RegistrationStatus IsMobileDevice={IsMobileDevice} Status={status} PhoneNumberData={phonenumberData} IsNewPhoneNumberFlow={true}></RegistrationStatus>
                            </Grid>
                        : verificationStatus
                            ? <Grid container direction="row" className={'paper-background br-2 b-around-text-field-border-4 p-5'} >
                                <VoiceVerification IsMobileDevice={IsMobileDevice} IsRehost={state?.IsReHost} handleStatus={handleVerificationStatus} PhoneNumberData={phonenumberData} AddressData={address} />
                            </Grid>
                            : <Grid container direction="row" className={'paper-background br-2 b-around-text-field-border-4 p-5'} >
                                <RegistrationStatus IsMobileDevice={IsMobileDevice} Status={status} PhoneNumberData={phonenumberData} IsNewPhoneNumberFlow={true}></RegistrationStatus>
                            </Grid>
            }
        </div>
    )
}
export default NewAddPhoneNumber;    